module.exports = __webpack_public_path__ + "img/chat-icon.910c56a3.svg";